import Joi from 'joi';
import { IntlFormatters } from 'react-intl';

export const addApplicationFormValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>) => {
  const applicationNameLabel = formatMessage({
    id: 'addApplicationModal_applicationName',
  });
  const shortDescriptionLabel = formatMessage({
    id: 'addApplicationModal_shortDescription',
  });
  const categoryLabel = formatMessage({
    id: 'addApplicationModal_category',
  });
  const productLabel = formatMessage({
    id: 'addApplicationModal_work_with',
  });
  const intendedUserLabel = formatMessage({
     id: 'addApplicationModal_intendedUserTitle'
  });
  const intendedPurposeLabel = formatMessage({
     id: 'addApplicationModal_intendedPurposeTitle'
  });

  return Joi.object({
    name: Joi.string()
      .trim()
      .required()
      .min(3)
      .max(100)
      .messages({
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: applicationNameLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: applicationNameLabel, min: 3, max: 100 }
        ),
        'string.min': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: applicationNameLabel, min: 3, max: 100 }
        ),
      }),
    short_description: Joi.string()
      .trim()
      .required()
      .min(15)
      .max(250)
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_allowed' },
          { field: shortDescriptionLabel }
        ),
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: shortDescriptionLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: shortDescriptionLabel, min: 15, max: 250 }
        ),
        'string.min': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: shortDescriptionLabel, min: 15, max: 250 }
        ),
      }),
    facing: Joi.string().required(),
    products: Joi.array()
      .has(Joi.string())
      .message(
        formatMessage(
          { id: 'generalForm_validation_required' },
          { field: productLabel }
        )
      ),
    categories: Joi.array()
      .has(Joi.string())
      .message(
        formatMessage(
          { id: 'generalForm_validation_required' },
          { field: categoryLabel }
        )
      ),
    intendedUsers: Joi.array()
    .has(Joi.string())
    .message(
      formatMessage(
        { id: 'generalForm_validation_required' },
        { field: intendedUserLabel }
      )
    ),
    intendedPurposes: Joi.array()
    .has(Joi.string())
    .message(
      formatMessage(
        { id: 'generalForm_validation_required' },
        { field: intendedPurposeLabel }
      )
    )
  });
};